// Hash content-addressed des vidéos, côté client.
// Sert à dédupliquer le stockage R2 et à réutiliser un résultat d'analyse IA
// identique quand deux utilisateurs envoient exactement la même vidéo. Le hash
// n'est jamais une donnée sensible : c'est un digest public de la vidéo.

// Calcule le SHA-256 (hex minuscule, 64 caractères) d'un Blob/File via Web
// Crypto. Fonction pure async : renvoie la chaîne hex, ou null si le calcul est
// impossible (pas de crypto.subtle, contexte non sécurisé, lecture échouée).
// En cas de null, l'appelant retombe simplement sur le flux sans hash.
export async function computeVideoHash(blob) {
  try {
    if (!blob || typeof blob.arrayBuffer !== 'function') return null;
    const subtle = globalThis.crypto && globalThis.crypto.subtle;
    if (!subtle) return null;
    const buf = await blob.arrayBuffer();
    const digest = await subtle.digest('SHA-256', buf);
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return null;
  }
}

// Valide qu'une valeur est bien un SHA-256 hex (64 caractères hexadécimaux
// minuscules). Garde-fou avant d'envoyer le hash au Worker.
export function isValidVideoHashHex(hash) {
  return typeof hash === 'string' && /^[a-f0-9]{64}$/.test(hash);
}
